<template>
    <div class="rotationChart">
        <FormRotationChart ref="form" @submitSuccess="getList"/>
        <FilterForm :fields="searchFields" @submit="search"/>
        <div class="groupButton">
            <AppButton customType="default" @click="addRotationChart">新增轮播图</AppButton>
        </div>
        <BasicTable :tableData="tableData" :columns="columns" >
            <template v-slot:images_url="{ item }">
                <div style="height: 5vw"><img :src="item.images_url" style="object-fit: contain;height: 5vw"/></div>
            </template>
            <template v-slot:is_enable="{ item }">
                <CheckBox v-model="item.is_enable" @change="enableRole(item)" ></CheckBox>
            </template>
            <template v-slot:add_time="{ item }">
                {{item.add_time*1000 | dateFormat('YYYY-MM-DD') }}
            </template>
            <template v-slot:operate="{ item }">
                <AppButton size="small" type="primary" plain @click="editRotationChart(item)"><i class="fa fa-edit fa-lg icon" ></i>编辑</AppButton>
                <AppButton size="small" type="primary" plain @click="delectRotationChart(item)"><i class="fa fa-trash-o fa-lg icon"></i>删除</AppButton>
            </template>
        </BasicTable>
    </div>
</template>

<script>
import { MessageBox } from 'element-ui';
import { WebsiteService } from '../../service/website.service'
import FormRotationChart from './formRotationChart'

const columns = [
  { name: '名称', key: 'name' },
  { name: '所属平台', key: 'platform' },
  { name : '轮播图片', key: 'images_url', type: 'custom'},
  { name: '是否启用', key: 'is_enable', type: 'custom' },
  { name: '创建时间', key: 'add_time',type: 'custom'},
  { name: '操作', key: 'operate', type: 'custom' },
];
const platform = [{value: 'weixin',label: '微信小程序'},{value: 'pc',label: 'PC网站'},{value: 'h5',label: 'h5手机网站'},{value: 'ios',label: '苹果APP'},{value: 'android',label: '安卓APP'},{value: 'alipay',label: '支付宝小程序'},{value: 'baidu',label: '百度小程序'}]
const event_type = [{value: '0',label: 'WEB页面'},{value: '1',label: '内部页面(小程序或APP内部地址)'},{value: '2',label: '外部小程序(同一个主体下的小程序APP)'},{value: '3',label: '打开地图'},{value: '4',label: '拨打电话'}]

export default {
    name: 'rotationChart',
    components: { FormRotationChart },
    data() {
        return {
            columns,
            platform,
            event_type,
            searchFields: [{
                key: 'name',
                id: '1',
                type: 'input',
                name: '名称',
            },{
                key: 'is_enable',
                id: '2',
                type: 'select',
                name: '启用',
                options: [{
                    value: '1',
                    label: '是'
                },{
                    value: '0',
                    label: '否'
                }]
            },{
                key: 'platform',
                id: '3',
                type: 'select',
                name: '平台',
                options: platform
            },{
                key: 'event_type',
                id: '4',
                type: 'select',
                name: '事件类型',
                options: event_type
            },{ 
                class: 'time',
                key: 'start_time',
                id: '5',
                type: 'date',
                name: '时间',
                placeholder: '起始时间'
            },{
                class: '',
                name: '~',
                key: 'end_time',
                id: '6',
                type: 'date',
                placeholder: '结束时间'
            }],
            tableData: [],
            query: []
        }
    },
    methods: {
        async getList() {
            const data = await WebsiteService.getList();
            this.tableData = data;
        },
        async search(val) {
            const data = await WebsiteService.getList(val);
            this.tableData = data;
        },
        editRotationChart(data) {
            this.$refs.form.open('edit', data,this.platform,this.event_type);
        },
        addRotationChart() {
            this.$refs.form.open('add','',this.platform,this.event_type);
        },
        enableRole(item) {
            WebsiteService.switchRoleStatus(item.id, item.is_enable ? 1 : 0);
        },
        async delectRotationChart(item) {
            MessageBox.confirm('确定要删除这条轮播图吗？', '删除轮播图').then(async () => {
                await WebsiteService.delectRotationChart(item.id)
                this.getList();
            })
        }
    },
    mounted() {
    },
    async created() {
      this.getList()
    }
}
</script>

<style lang="scss">
    .rotationChart{
        .time.el-form-item{
            clear: both;
            .el-date-editor.el-input{
                width: auto;
            }
        }
        .edui-default .view::after{
            width: 100%;
            height: 100%;
            background: blue;
            border: 0!important;
            box-shadow: none!important;
        }
        .edui-editor-iframeholder,.edui-editor-bottomContainer{
            display: none;
        }
        .edui-toolbar{
            text-align: left;
        }
    }
</style>>
    
